import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ConsentState, DEFAULT_CONSENT } from "./types";
import ConsentManager from "./ConsentManager";

export interface CookieConsentState {
  isBannerOpen: boolean;
  hasUserConsented: boolean;
  currentConsent: ConsentState;
}

// Check if consent exists on load using the static method
const savedConsent = ConsentManager.getSavedConsent();

const initialState: CookieConsentState = {
  // If no consent is saved, show the banner
  isBannerOpen: !savedConsent,
  hasUserConsented: !!savedConsent,
  currentConsent: savedConsent || DEFAULT_CONSENT,
};

export const cookieConsentSlice = createSlice({
  name: "cookieConsent",
  initialState,
  reducers: {
    setConsent: (state, action: PayloadAction<ConsentState>) => {
      state.currentConsent = action.payload;
      state.hasUserConsented = true;
      state.isBannerOpen = false;

      // Sync with the Gatekeeper (Vanilla JS)
      if (window.ThemeConsent) {
        window.ThemeConsent.update(action.payload);
      }
    },
    openBanner: (state) => {
      state.isBannerOpen = true;
    },
    closeBanner: (state) => {
      state.isBannerOpen = false;
    },
  },
});

export const { setConsent, openBanner, closeBanner } =
  cookieConsentSlice.actions;

export default cookieConsentSlice.reducer;
